import { BaseQuantity } from "../../interface/functionalityInterface";
// Derived base quantity
// coherent SI unit is m2
export const Area: BaseQuantity = {
  id: "001area",
  name: "area",
  type: "numeric",
  value: "",
  symbol: "A",
  baseUnit: "m\u00b2",
  selectedUnit: "m\u00b2",
  units: [
    { name: "m\u00b2", fromConst: 1, toConst: 1 },
    { name: "mm\u00b2", fromConst: 1 / 1000 ** 2, toConst: 1000 ** 2 },
    { name: "cm\u00b2", fromConst: 1 / 100 ** 2, toConst: 100 ** 2 },
    { name: "dm\u00b2", fromConst: 1 / 10 ** 2, toConst: 10 ** 2 },
    { name: "ha", fromConst: 10000 ** 2, toConst: 1 / 10000 ** 2 },
    { name: "in\u00b2", fromConst: 1 / 1550.003, toConst: 1550.003 },
    { name: "ft\u00b2", fromConst: 1 / 10.7639, toConst: 10.7639 },
    { name: "yd\u00b2", fromConst: 1 / 1.196, toConst: 1.19599 },
    {
      name: "mi\u00b2",
      fromConst: 2.59 * 10 ** 6,
      toConst: 3.86102 * 10 ** -7,
    },
  ],
};
